import { ElementType } from 'react';
import { CheckCircle, Info } from 'lucide-react';

import { useNavigate } from 'react-router-dom';

import { cn } from '@client/lib';

interface AdvisorOnboardingActionCardProps {
  icon: ElementType;
  title: string;
  description: string;
  path: string;
  isCompleted?: boolean;
}

export function AdvisorOnboardingActionCard({
  icon: Icon,
  title,
  description,
  path,
  isCompleted,
}: AdvisorOnboardingActionCardProps) {
  const navigate = useNavigate();

  function handleClick() {
    if (!isCompleted) {
      navigate(path);
    }
  }

  return (
    <button
      onClick={handleClick}
      disabled={isCompleted}
      className={cn(
        'flex w-full cursor-pointer items-center gap-4 rounded-xl border border-gray-200 bg-gray-50 p-4 text-start transition-colors hover:bg-transparent',
        {
          'pointer-events-none opacity-70': isCompleted,
        },
      )}
    >
      <div className="bg-primary/10 text-primary flex size-12 shrink-0 items-center justify-center rounded-md">
        <Icon className="size-5" />
      </div>
      <div>
        <h3 className="font-medium text-gray-950">{title}</h3>
        <p className="text-balance text-sm text-gray-600">{description}</p>
      </div>
      <div className="ml-auto mr-3">
        {isCompleted ? (
          <CheckCircle className="size-7 text-green-700 contrast-200" />
        ) : (
          <Info className="size-7 text-amber-600 contrast-150" />
        )}
      </div>
    </button>
  );
}
